window.customGravityFormsHook = function customGravityFormsHook($) {
  $("#input_8_8_1, #input_8_8_2").on("change", function (e) {
    //For some reason GF chained selects does not handle dom changes
    $(this).attr("value", e.target.value);
  });

  $('form[id^="gform_5"], form[id^="gform_6"], form[id^="gform_7"]')
    .on("change", function (e) {
      var $reqd = $(this)
        .find(".gfield_contains_required.gfield_visibility_visible")
        .filter(function (i, c) {
          return []
            .concat(
              $(c)
                .find('input[type="text"], textarea')
                .filter(function (i, fl) {
                  return $(fl).val().length == 0;
                })
                .get(),
            )
            .concat($(c).find('input[type="checkbox"]').not(":checked").get())
            .length;
        });

      if ($reqd.length) {
        $(this).find('input[type="submit"]').attr("disabled", true);
      } else {
        $(this).find('input[type="submit"]').removeAttr("disabled");
      }
    })
    .trigger("change");

  //SoluForms only
  $('form[id^="gform_8"], form[id^="gform_9"]')
    .on("change", function (e) {
      var $reqd = $(this)
        .find(".gfield_contains_required.gfield_visibility_visible")
        .filter(function (i, c) {
          return []
            .concat(
              $(c)
                .find("select")
                .filter(function (i, fl) {
                  return $(fl).val() ? false : true;
                })
                .get(),
            )
            .concat(
              $(c)
                .find('input[type="text"], textarea')
                .filter(function (i, fl) {
                  return $(fl).val().length == 0;
                })
                .get(),
            )
            .concat($(c).find('input[type="checkbox"]').not(":checked").get())
            .length;
        });
      if ($reqd.length) {
        $(this).find('input[type="submit"]').attr("disabled", true);
      } else {
        $(this).find('input[type="submit"]').removeAttr("disabled");
      }
    })
    .trigger("change");
};

window.customGravityFormsHook(jQuery);
